import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/salary-negotiation-script/NegotiationScriptContent.tsx");
